import React from "react";
import "../../Styles/yellowcalf.css/Special_Fee_Report.css";

function Special_Fee_Report() {
  return (
    <div className="special-fee-container" style={{ paddingTop: "25px" }}>
      <div className="special-fee-header">
        <h3>Special Fee Report</h3>
        <div className="export-btn-container-special">
          <button className="export-btn-special">
            Export <span className="arrow-down-special"></span>
          </button>
        </div>
      </div>

      {/* Filter + Table Section */}
      <div className="special-fee-body">
        <div className="filter-section-special">
          <select className="parent-select-special">
            <option value="">Select Parent</option>
          </select>
          <button className="search-btn-special">Search</button>
        </div>

        {/* Table */}
        <div className="table-container-special">
          <table className="special-fee-table">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Invoice ID</th>
                <th>Student</th>
                <th>Academic Year</th>
                <th>Demand Date</th>
                <th>Amount Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="6" className="no-results-special">
                  No results found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Special_Fee_Report;
